import React from 'react';
import TextField from "@material-ui/core/TextField";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
    DatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {isToday, setDefaultOptions} from "date-fns";
import {useFormStateDispatch} from "../FormComponents/FormState";
const { zonedTimeToUtc, utcToZonedTime, format } = require('date-fns-tz');
const { parse } = require('date-fns');

setDefaultOptions({ weekStartsOn: 1 });

function Datepicker(props) {
    const { disabled, field, input, meta: { touched, error } } = props;
    const orderEntryDispatch = useFormStateDispatch();

    if (field.type === 'number') {
        input.min = 1;
    }

    const value = input.value ? parse(input.value, 'dd.MM.yyyy', new Date()) : input.value === 'error' ? 'error' : null;

    const change = (value) => {
        if(Object.prototype.toString.call(value) === "[object Date]" && !isNaN(value.getTime())) {
            input.onChange(format(value, 'dd.MM.yyyy'));
            field.onChangeCallback?.(format(value, 'dd.MM.yyyy'), orderEntryDispatch);
            return;
        }
        input.onChange('error');
        return;
    }

    const input2 = {
        ...input,
        onChange: change,
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
                //disableToolbar
                //openTo="year"
                //variant="inline"
                inputVariant="outlined"
                format="dd.MM.yyyy"
                id="date-picker-inline"
                label={field.required ? <>{field.label} *</> : field.label}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                autoOk={true}
                disablePast={field.allowPast ? false : true}
                //maxDate={new Date()}
                i//nitialFocusedDate={new Date('1990-01-01T00:00:00.000')}
                {...input2}
                InputLabelProps={{
                    shrink: value,
                }}
                value={value}
                invalidDateMessage={<span>Invalid</span>}
                error={touched && error}
                helperText={touched && error }
                inline
                shouldDisableDate={field?.shouldDisableDate ? field.shouldDisableDate : field.preventWeekends ? (date) => date.getDay() === 0 || date.getDay() === 6 || isToday(date) : false }
                disableToolbar={field.allowToolbar ? false : true}
                variant="inline"
                maxDate={field.maxDate}
                disabled={disabled}
            />
        </MuiPickersUtilsProvider>
        //   <TextField
        //     id={input.name}
        //     label={field.label}
        //     name={input.name}
        //     helperText={touched && error }
        //     error={touched && error}
        //     {...input}
        //     type={'date'}
        //     InputLabelProps={{
        //       shrink: true,
        //     }}
        //     inputProps={{
        //       pattern: '\\d{1,2}.\\d{1,2}.\\d{4}',
        //       title: '01.01.2000',
        //     }}
        //   />
    );
}

export default Datepicker;
